module.exports = __webpack_public_path__ + "img/icons_instagram.d1e641d2.svg";